module.exports = __webpack_public_path__ + "static/media/phantom.31a4d651.svg";